import * as S from "./JoinTemplate.style";
import { Header } from "@/components/organisms/Header";
import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

interface JoinTemplateProps {
  children: React.ReactElement;
}

export const JoinTemplate = ({ children }: JoinTemplateProps) => {
  const navigate = useNavigate();

  return (
    <S.JoinTemplate>
      <Header
        headerTitle="회원가입"
        buttonLeft={
          <Buttons
            type="button"
            size="headerTextIcon"
            layout="text"
            color="bright100"
            icon={<IconArrow />}
            label="메인"
            onClick={() => navigate("/auth/login")}
          />
        }
      />
      <S.JoinContent>{children}</S.JoinContent>
    </S.JoinTemplate>
  );
};
